/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */

import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useInvitation } from '../hooks/useInvitation';

const AcceptInvitationPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const { verifyInvitation, loading } = useInvitation();

    const [error, setError] = useState('');

    useEffect(() => {
        const verify = async () => {
            const token = searchParams.get('token');

            if (!token) {
                setError('Invalid invitation link');
                return;
            }

            try {
                const response = await verifyInvitation(token);

                if (!response.success) {
                    setError(
                        response.message ||
                        'Invalid or expired invitation'
                    );
                    return;
                }

                navigate(
                    `/signup?token=${encodeURIComponent(token)}`,
                    {
                        replace: true,
                    }
                );
            } catch (err) {
                console.error('Invitation verification failed:', err);

                setError('Unable to verify invitation. Please try again.');
            }
        };

        verify();
    }, [searchParams, verifyInvitation, navigate]);

    if (loading) {
        return <div>Verifying invitation...</div>;
    }

    if (error) {
        return (
            <div>
                <h2>Invitation Invalid</h2>
                <p>{error}</p>
            </div>
        );
    }

    return null;
};

export default AcceptInvitationPage;